import { ActivatedRoute } from '@angular/router';
import { AdministrationCommonListComponent } from '@admin/components/administration-common-list/administration-common-list.component';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StateService } from '@core/services/state/state.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-administration-subaccounts-list',
	standalone: false,
	imports: [],
	templateUrl: './administration-subaccounts-list.component.html',
	styleUrl: './administration-subaccounts-list.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministrationSubaccountsListComponent extends AdministrationCommonListComponent {
	constructor(
		protected translate: TranslateService,
		protected route: ActivatedRoute,
		protected stateService: StateService
	) {
		super(translate, route, stateService);
	}

	onSubAccountSearch(value: string): void {
		const pattern = new RegExp(value, 'i');
		this.list = this.originalList.filter((item: any) => item.name.match(pattern));

	}

	subaccountsListCellProperties(columnIndex) {
		let styleObject = {
			width: '',
			vertical_align: '',
			text_align: ''
		};
		switch (columnIndex) {
			case 2:
			case 4:
				styleObject.width = '100px';
				return styleObject;
			case 3:
				styleObject.width = '100px';
				styleObject.text_align = 'center';
				return styleObject;
			default:
				styleObject.width = 'auto';
				return styleObject;
		}
	}
}
